export default __webpack_public_path__ + "static/media/Water_sensor.cd650bce.svg";